export default function gridOverlay() {
  let showGrid = false;
  const gridOverlayEl = document.querySelector(".grid-overlay");

  const setState = (newState: boolean) => {
    showGrid = newState;

    if (newState) {
      window.localStorage.setItem("showGrid", "true");
      gridOverlayEl?.classList.add("grid-overlay--active");
    } else {
      window.localStorage.removeItem("showGrid");
      gridOverlayEl?.classList.remove("grid-overlay--active");
    }
  };

  if (gridOverlayEl) {
    setState(window.localStorage.getItem("showGrid") === "true");

    // Keyboard toggle (Ctrl+G)
    document.addEventListener("keyup", (evt: KeyboardEvent) => {
      if (evt.ctrlKey && evt.key === "g") {
        setState(!showGrid);
      }
    });
  }
}
